import React, { useContext, useEffect, useState } from 'react';
import logo from '../Imagens/logo Jabil.png';
import Cabecalho from './Cabecalho';
import '../Estilos/Header.css';
import Hamburguer from './Hamburguer';
import useWindowSize from '../Hooks/windowSize';

/**
 *
 * @returns
 */
export default function HeaderNavegacao(props) {
  const windowSize = useWindowSize();
  const [menuPressed, setMenuPressed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);


  useEffect(() => {
    setIsMobile(windowSize.width < 920);
  }, [windowSize]);

  return (
    <div className="Container">
      {!isMobile ?
        (<div
          style={{
            backgroundColor: menuPressed ? '#005288' : 'white',
            borderRight: '1px solid #0A629B',
            minWidth: '110px',
            height: '80px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
          }}
          onClick={() => {
            props.menuHamburguerEvent(!menuPressed);
            setMenuPressed(!menuPressed);
          }}
        >
          {!menuPressed ? (
            <img src={require('../Icones/hamburguer.png')} alt="LOGO" className="imagem" />
          ) : (
            <h1 style={{ color: 'white', fontSize: 38, fontWeight: 400 }}>X</h1>
          )}
        </div>) : <Hamburguer />

      }
      {isMobile ? <Hamburguer /> : <Cabecalho />}
    </div>
  );
}
